<template>
  <div class="dict">
    <h2>数据字典</h2>
    <el-form :inline="true">
      <el-form-item label="字典类型">
        <el-select v-model="searchParam.code" filterable @change="commitFindList()" style="width: 120px;">
          <el-option v-for="dictCodeItem in data.dictCodeList" :key="dictCodeItem.code" :label="dictCodeItem.name" :value="dictCodeItem.code" />
        </el-select>
      </el-form-item>
    </el-form>
    <el-table :data="data.dictList" border height="calc(100vh - 220px)">
      <el-table-column type="index" width="60" />
      <el-table-column label="操作" width="60">
        <template #default="scope">
          <el-link v-if="scope.row.id" type="danger" @click="del(scope.row)" :disabled="show.saving">删除</el-link>
          <el-text v-else>新增</el-text>
        </template>
      </el-table-column>
      <el-table-column prop="value" label="字典值">
        <template #default="scope">
          <el-input v-model="scope.row.value" :maxlength="100" @change="save(scope.row, 'value')" />
        </template>
      </el-table-column>
      <el-table-column v-if="searchParam.code === 'product'" prop="productHeatType" label="热值类型">
        <template #default="scope">
          <el-select v-model="scope.row.productHeatType" filterable @change="save(scope.row, 'productHeatType')">
            <el-option label="高卡" value="HIGH" />
            <el-option label="中卡" value="MEDIUM" />
            <el-option label="低卡" value="LOW" />
          </el-select>
        </template>
      </el-table-column>
      <el-table-column v-if="searchParam.code === 'productSpecs'" prop="product" label="对应煤矿品名">
        <template #default="scope">
          <el-select v-model="scope.row.product" filterable :placeholder="scope.row.value ? '请选择' : '请先填写产品规格'" :disabled="!scope.row.value" @change="save(scope.row, 'product')">
            <el-option v-for="productItem in data.productList" :key="productItem.id" :label="productItem.value" :value="productItem.value" />
          </el-select>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script setup>
import { reactive } from 'vue'
import { ElMessage } from 'element-plus'
import api from '../../apis/api'

const data = reactive({
  dictCodeList: [],
  dictList: [],
  productList: []
})

const show = reactive({
  saving: false
})

const searchParam = reactive({
  code: null
})

api.get('/backend/dict/getAllCode').then(res => {
  data.dictCodeList = res.dictCodeList
})
// 产品规格的「对应煤矿品名」只能从已填写的品名中选
api.get('/backend/dict/getByCode', { params: { code: 'product' } }).then(res => {
  data.productList = res.dictList
})

const commitFindList = () => {
  if (!searchParam.code) {
    ElMessage.error('请先选择字典类型')
    return
  }
  data.dictList = []
  api.get('/backend/dict/getByCode', {
    params: {
      code: searchParam.code
    }
  }).then(res => {
    data.dictList = res.dictList
    data.dictList.push({})
  })
}

const save = (row, cname) => {
  const param = { id: row.id, value: row.value }
  param[cname] = row[cname]
  if (!param.id) {
    param.code = searchParam.code
  }
  api.post('/backend/dict/set', param).then(() => {
    commitFindList()
    ElMessage.success('更新成功')
  })
}

const del = (row) => {
  if (show.saving) {
    return
  }
  show.saving = true
  api.post('/backend/dict/del', { id: row.id }).then(() => {
    commitFindList()
    ElMessage.success('更新成功')
  }).finally(() => {
    show.saving = false
  })
}
</script>

<style lang="less"></style>